<template>
  <v-card width="100%" height="100%" outlined>
    <v-toolbar color="accent" dark class="title" flat>
      <v-icon left>fas fa-user</v-icon>
      Account Disabled:
    </v-toolbar>
    <v-container fluid>
      <v-row>
        <v-col sm="12" class="subtitle-1 text-center">
          Your account has been disabled.<br><br>Please contact The Mount office if you have questions.
        </v-col>
      </v-row>
    </v-container>
  </v-card>
</template>

<script>
  export default {

  }
</script>
